module.exports = __webpack_public_path__ + "img/thanks.a8b17786.png";